import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MysService {

  constructor(private http: HttpClient,
    private environmentService: EnvironmentService) { }

  getToken(){
    let serviceurl = this.environmentService.getEnvironmentUrl(
      'service/mys-token'
    );
    return this.http.get(serviceurl);
  }
}

